import { createImageUrlBuilder } from '@sanity/image-url';
import { sanityClient } from 'lib/sanity/client';

export { sanityClient as client } from 'lib/sanity/client';
export { useImage } from 'lib/sanity/useImage';

export const imageUrlBuilder = createImageUrlBuilder(sanityClient);
